import { Component } from '@angular/core';

@Component({
	selector: 'app-promotion',
	templateUrl: './promotion.component.html',
	styleUrls: ['./promotion.component.css']
})
export class PromotionComponent {

	constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/promotion/promotion.component.ts